import React, { Component } from 'react'
import PostIntro from '../../components/PostIntro';
import AnimationScroll from '../../components/AnimationScroll';
import ScrollMagic from 'scrollmagic';
import Helmet from '../Helmet';
import './style.scss';
import './gallery.scss';

export default class Post extends Component {
  htmlDecode(input){
    var e = document.createElement('div');
    e.innerHTML = input;
    return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
  }

  replaceNbsps(str) {
    var re = new RegExp(String.fromCharCode(160), "g");
    return str.replace(re, " ");
  }


  catListClasses = (catList) => {
    let catNames = [];
    let str = ''
    catList.map((cat) => {
      catNames.push(cat.slug);
      str = str + 'cat-'+cat.slug + ' ';
    });

    return str

  }


  render() {

    if(this.props.data.wordpressPost)
      console.log(this.props.data.wordpressPost)
    
    if(this.props.data.wordpressPost)
      return (
        <div style={{ height:'100%' }}>
         <Helmet
        title={ this.replaceNbsps(this.props.data.wordpressPost.title).replace(/[&]nbsp[;]/gi," ") + ' //// Studio Gritt' }
        description={this.props.data.wordpressPost.excerpt.replace(/<\/?[^>]+(>|$)/g, "")}
        image={this.props.data.wordpressPost.featured_media.source_url}
      />
          <div style={{ height:'100%', marginBottom:'70px' }}>
              <PostIntro title={this.props.data.wordpressPost.title} bg={this.props.data.wordpressPost.featured_media.localFile.childImageSharp.sizes} type="Interior" />
          </div>
          <div className="post-content">
              <div className={'container ' + this.catListClasses(this.props.data.wordpressPost.categories)}>

              
                <AnimationScroll>    
                  <div className="pcontent"  dangerouslySetInnerHTML={{ __html: this.props.data.wordpressPost.content }} ></div>
                </AnimationScroll>
              </div>
          </div>        
        </div>
      )

    return (
      <div>Hello</div>
    )
  }
}


export const pageQuery = graphql`
  query currentPostQuery($id: String!) {
    wordpressPost(id: { eq: $id }) {
      title
      content
      excerpt
      categories  {
        wordpress_id
        slug
      }
        featured_media {
            id
            source_url

            localFile {
                childImageSharp {
                  sizes(maxWidth: 680) {
                    ...GatsbyImageSharpSizes
                  }
                }
            }
        }
    }
    site {
      siteMetadata {
        title
       
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/components/post/index.js